import { transparentPNG } from '../utilities/image'

export const avatarUrl = (id: number | string, size = 150) => {
    if (!id) {
        return transparentPNG
    }
    const prefix = String(id).slice(0, 3)
    const x = String(size)
    const y = String(size)
    return `https://img.mfcimg.com/photos2/${prefix}/${id}/avatar.${x}x${y}.jpg`
}

export const previewSnapshotUrl = (
    channel: string | number,
    server: string | number,
    cache?: number,
    large?: boolean,
    xsmall?: boolean,
) => {
    if (!channel || !server) {
        return transparentPNG
    }
    return (
        'https://snap.mfcimg.com/' +
        `snapimg/${server}/${
            large ? '640x480' : xsmall ? '160x120' : '320x240'
        }/mfc_${channel}` +
        (cache ? `?no-cache=${cache}` : '')
    )
}
